import React from 'react';

import { useMutation } from '@tanstack/react-query';

import ImportService from '../../../services/ImportService';
import { useUiContext } from '../../../context/UiContext';

export default function FinalizeButton({ importId }) {
  const { showDialogModal, showToast } = useUiContext();

  const { mutate: finalizeImport, isPending } = useMutation({
    mutationFn: () => ImportService.finalizeImport(importId),
    onSuccess: () => {
      showToast({
        text: 'Import finalized successfully',
        type: 'success',
      });
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  return (
    <button
      className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
      type="button"
      disabled={isPending}
      onClick={() => {
        showDialogModal({
          title: 'Finalize Import',
          message:
            'Are you sure you want to finalize this import? The import will be marked complete and the loan will be marked active.',
          onConfirm: finalizeImport,
          type: 'warning',
          confirmButtonLabel: 'Yes, finalize',
          cancelButtonLabel: 'No, cancel',
        });
      }}
    >
      Finalize
    </button>
  );
}
